export const DEFAULT_SLIPPAGE = 3;
export const MIN_SLIPPAGE = 0.01;
export const MAX_SLIPPAGE = 50;
export const DEFAULT_DEADLINE = 20; // in minutes
export const MIN_DEADLINE = 1; // in minutes
export const MAX_DEADLINE = 120; // in minutes

export const WRAPPED_CSPR_PACKAGE_HASH = config.wrapped_cspr_contract_package_hash?.replace('hash-', '');

export const DEFAULT_PAYMENT_AMOUNT = {
  approve: 5000000000, // 5 CSPR
  addNewLiquidity: 500000000000, // 500 CSPR
  addLiquidity: 50000000000, // 50 CSPR
  swapCsprForToken: 15_000_000_000, // 15 CSPR
  swapTokenForToken: 15_000_000_000, // 15 CSPR
};

export const TTL = 1800000;

export const CSPR_TOKEN = {
  id: 'cspr',
  symbol: 'CSPR',
};

export const ZERO_HASH = '0000000000000000000000000000000000000000000000000000000000000000';
export const SWAP_PRICE_IMPACT_WARNING_THRESHOLD = 10; // 10%
export const HIGH_SLIPPAGE_WARNING_THRESHOLD = 10; // 10%
export const SWAP_PROTOCOL_FEE = 0.003;
export const BLOCK_INTERVAL_MS = 8000;
export const POSSIBLE_QUOTE_LATENCY_MS = 500;

export const SLIPPAGE_STORAGE_KEY = 'slippage-asdg9';
export const DEADLINE_STORAGE_KEY = 'deadline-98dds';

export const NO_FIAT_RATE_LABEL = 'N/A';
